
import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type { ServiceResponse, UUID } from '@dopomogai/types';
import type { MyWidgetConversationList, MyWidgetConversationDetail } from '@dopomogai/types';

export const myWidgetConversationsService = {
  list: (widgetVersionId: UUID, limit = 10, offset = 0): ServiceResponse<MyWidgetConversationList> => {
    return getApiClient()
      .get<MyWidgetConversationList>(`/widgets/${widgetVersionId}/conversations`, { params: { limit, offset } })
      .then(res => res.data)
      .catch(err => handleApiError(err, `listing my widget conversations for ${widgetVersionId}`));
  },

  getOne: (widgetVersionId: UUID, conversationId: string): ServiceResponse<MyWidgetConversationDetail> => {
    return getApiClient()
      .get<MyWidgetConversationDetail>(`/widgets/${widgetVersionId}/conversations/${conversationId}`)
      .then(res => res.data)
      .catch(err => handleApiError(err, `fetching my widget conversation ${conversationId}`));
  },
};